export default "__VITE_ASSET__CWU2GGoP__"